import axios from "axios";
import { customerRequestOptions, newCustomerRequestId } from "./customerService";

export const BENEFITS_API = (process.env.REACT_APP_POS_API_BASE_URL || process.env.REACT_APP_API_BASE_URL || "https://doticom.vn:3000").replace(/\/+$/, "");
export const benefitError = error => error.response?.data?.message || error.message || "Không thể thực hiện. Vui lòng thử lại.";
export const benefitGet = async (path, params, signal) => (await axios.get(`${BENEFITS_API}${path}`, customerRequestOptions({ params, signal }))).data;
export const benefitPost = async (path, body) => (await axios.post(`${BENEFITS_API}${path}`, body, customerRequestOptions())).data;
export const publicBenefitGet = async (path, params, signal) => (await axios.get(`${BENEFITS_API}${path}`, { params, signal })).data;

export async function benefitMutation(method, path, payload) {
  const storageKey = `pendingBenefit:${method}:${path}`;
  const signature = JSON.stringify(payload);
  let pending;
  try { pending = JSON.parse(sessionStorage.getItem(storageKey) || "null"); } catch { pending = null; }
  if (pending?.signature !== signature) {
    pending = { signature, requestId: newCustomerRequestId() };
    sessionStorage.setItem(storageKey, JSON.stringify(pending));
  }
  const result = await axios[method](`${BENEFITS_API}${path}`, { ...payload, requestId: pending.requestId }, customerRequestOptions());
  sessionStorage.removeItem(storageKey);
  return result.data;
}
export const benefitNumber = value => Number(value || 0).toLocaleString("vi-VN");
export const benefitDate = value => {
  const parts = String(value || "").slice(0, 10).split("-");
  return parts.length === 3 ? `${parts[2]}/${parts[1]}/${parts[0]}` : "—";
};
export const voucherLabels = { available: "Có thể sử dụng", used: "Đã sử dụng", revoked: "Đã thu hồi", paused: "Tạm ngưng", upcoming: "Chưa đến hạn", expired: "Hết hạn" };
